export const FETCH_REPORT_DATA = 'benchmarking/FETCH_REPORT_DATA';
export const GENERATE_BENCHMARK_REPORT = `benchmarking/GENERATE_BENCHMARK_REPORT`;
export const REQUEST_VFM_REPORT = `REQUEST_VFM_REPORT`;
